const helpers = require('./helpers')

/* Internal Functions */

function _firePageTrackingEvent(trackObj) {
  if (typeof window.s !== 'undefined' && typeof window.s.t !== 'undefined') {
    Object.assign(window.s, trackObj)
    if (window.location.href.indexOf('debug') !== -1)
      window.sDebugLog.push(Object.assign({}, window.s))
    window.s.t()
  }
}

function _fireCustomTrackingEvent(trackObj, type, eventName) {
  if (typeof window.s !== 'undefined' && typeof window.s.tl !== 'undefined') {
    Object.assign(window.s, trackObj)
    if (window.location.href.indexOf('debug') !== -1)
      window.sDebugLog.push(Object.assign({}, window.s))
    window.s.tl(true, type, eventName)
  }
}

function _clearVars() {
  if (typeof window.s !== 'undefined') {
    if (typeof window.s.clearVars !== 'undefined') {
      window.s.clearVars()
    }
    window.s.contextData = {}
    window.s.linkTrackVars = ''
  }
}

/* Exported functions */
function setOmnitureGlobalVariable(config) {
  window.visitor = window.Visitor.getInstance(config.mc_id, {
    trackingServer: config.s.trackingServer,
    trackingServerSecure: config.s.trackingServerSecure,
    // Variables for CNAME support
    marketingCloudServer: config.s.trackingServer,
    marketingCloudServerSecure: config.s.trackingServerSecure,
  })
  window.s = Object.assign(
    window.s_gi(config.omniture_account_id),
    window.s,
    config.s
  )
  window.s.visitor = window.Visitor.getInstance(config.mc_id)
}

function trackPageWithContext(context) {
  const linkTrackVars = []
  for (const key in context) {
    linkTrackVars.push('contextData.' + key)
    context[key] += ''
  }
  const omnitureContext = {
    contextData: context,
    linkTrackVars: linkTrackVars.join(','),
  }
  helpers.logTracking('Page Tracking Context', omnitureContext.contextData)
  _firePageTrackingEvent(omnitureContext)
  _clearVars()
}

function trackCustomEventWithContext(context, productName) {
  const linkTrackVars = []
  for (const key in context) {
    linkTrackVars.push('contextData.' + key)
    context[key] += ''
  }
  const omnitureContext = {
    contextData: context,
    linkTrackVars: linkTrackVars.join(','),
  }
  helpers.logTracking('Custom Tracking Context', omnitureContext.contextData)
  _fireCustomTrackingEvent(omnitureContext, 'o', productName)
  _clearVars()
}

function getLoadTime() {
  return window.s.getLoadTime()
}

function getPercentPageViewed() {
  return window.s.getPercentPageViewed()
}

function getPreviousPageViewed(currentPageName) {
  const currentPage = currentPageName || window.s.pageName
  let prevPage = window.s.getPreviousValue(currentPage, 's_previouspage')
  prevPage = (prevPage !== 'no value' && prevPage) || currentPage
  return prevPage
}

module.exports = {
  setOmnitureGlobalVariable,
  trackPageWithContext,
  trackCustomEventWithContext,
  getLoadTime,
  getPercentPageViewed,
  getPreviousPageViewed,
}
